var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6059_29203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.782471 9.86426C0.972551 11.6789 1.76296 13.4426 3.15369 14.8334C4.54442 16.2241 6.30815 17.0145 8.12287 17.2046L0.782471 9.86426Z",
    fill: "#5643CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.750244 8.5356L9.45134 17.2366C10.1897 17.1953 10.9235 17.0552 11.6314 16.8163L1.17054 6.35547C0.93168 7.06335 0.791586 7.79722 0.750244 8.5356Z",
    fill: "#5643CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54517 5.43421L12.553 16.4421C13.1241 16.1685 13.6703 15.8254 14.1787 15.4127L2.57457 3.80859C2.16194 4.31703 1.8188 4.86314 1.54517 5.43421Z",
    fill: "#5643CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19116 3.12891C6.4159 -0.0554109 11.6115 -0.0429166 14.8207 3.16637C18.03 6.37566 18.0425 11.5712 14.8582 14.7959L3.19116 3.12891Z",
    fill: "#5643CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6059_29203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearIcon);
export default __webpack_public_path__ + "static/media/linear-icon.fc3f54cf318832e495cc25c8402d1a2c.svg";
export { ForwardRef as ReactComponent };